const state = {
  logo: "",
  appLoaded: false,
  defaultLayoutLoaded: false,
  authMessage: {
    status: false,
    message: "",
    variant: "",
  }, // Uygulamada eğer authorization işlemlerinde problem varsa hata mesajı döner.
  appActionModal: {
    status: false,
    isLoading: false,
    message: "Bir yeni mesaj",
    variant: "info",
  }, // herhangi bir async işlemde yaşanacak problemlerde gösterilen alert modal'ı // 2. herhangi bir işlem işlem durumunu gösteren modal.
  appIframeDrawer: {
    status: false,
    title: "",
    src: "",
    size: "lg",
  },
  workedDays: {
    workedDay: 0,
    workDaysAfterToday: 0,
    storageCreatedDate: "",
    diffDays: 0,
    today: 0,
    workedDaysModal: false,
  },
};
const getters = {
  getAppLoaded: (state) => state.appLoaded,
  getDefaultLayoutLoaded: (state) => state.defaultLayoutLoaded,
  getLogo: (state) => state.logo,
  getAuthMessage: (state) => state.authMessage,
  getActionModal: (state) => state.appActionModal,
  getIframeDrawer: (state) => state.appIframeDrawer,
  getWorkedDays: (state) => state.workedDays,
};
const mutations = {
  //  default layout: Uygulama tamamen yüklendi ise.
  SET_APP_LOADED(state, payload) {
    state.appLoaded = payload;
  },
  //  default layout: Uygulama tamamen yüklendi ise.
  SET_DEFAULT_LAYOUT_LOADED(state, payload) {
    console.log(payload, "payloadd...");
    state.defaultLayoutLoaded = payload;
  },
  // Uygulamada eğer authorization işlemlerinde problem varsa hata mesajı döner.
  SET_AUTH_MESSAGE(state, payload) {
    state.authMessage = payload;
  },
  SET_LOADING(state, payload) {
    state.appActionModal = {
      status: payload,
      isLoading: payload,
      message: "",
      variant: "",
    };
  },
  // 1. herhangi bir async işlemde yaşanacak problemlerde gösterilen alert modal'ı
  // 2. herhangi bir işlem işlem durumunu gösteren modal.
  SET_ACTION_MODAL(state, payload) {
    state.appActionModal = payload;
  },
  SET_RESET_ACTION_MODAL(state) {
    state.appActionModal = {
      status: false,
      isLoading: false,
      message: "",
      variant: "",
      duration: 1000 * 60 * 60 * 24,
    };
  },
  SET_IFRAME_DRAWER(state, payload) {
    state.appIframeDrawer = payload;
  },
  SET_RESET_IFRAME_DRAWER(state) {
    state.appIframeDrawer = {
      status: false,
      title: "",
      src: "",
      size: "lg",
    };
  },
  SET_WORKED_DAYS(state, payload) {
    state.workedDays = {
      workedDay: Number(payload.workedDay),
      workDaysAfterToday: Number(payload.workDaysAfterToday),
      storageCreatedDate: payload.storageCreatedDate,
      diffDays: Number(payload.diffDays),
      today: Number(payload.today),
      workedDaysModal: payload.workedDaysModal,
    };
  },
  SET_WORKED_DAYS_MODAL(state, payload) {
    state.workedDays.workedDaysModal = payload;
  },
  SET_RESET_WORKED_DAYS(state) {
    state.workedDays = {
      workedDay: 0,
      workDaysAfterToday: 0,
      storageCreatedDate: "",
      diffDays: 0,
      today: 0,
      workedDaysModal: false,
    };
  },
};

const actions = {
  // herhangi bir async işlemde yaşanacak problemlerde gösterilen alert modal'ı
  // tüm async işlemlerde durumun sonucunu gösteren alert.
  SET_ACTION_MODAL({ commit }, payload) {
    commit("SET_ACTION_MODAL", payload);
    setTimeout(() => {
      commit("SET_RESET_ACTION_MODAL");
    }, payload.duration || 4000);
  },
  // async işlem modal ile loading gösterimi.
  SET_ACTION_MODAL_LOADING({ commit }) {
    commit("SET_ACTION_MODAL", {
      status: true,
      isLoading: true,
      message: "Bir yeni mesaj",
      variant: "",
    });
  },
  SET_IFRAME_DRAWER({ commit }, payload) {
    const baseUrl = `${window.location.origin}${window.location.pathname}`;
    commit("SET_IFRAME_DRAWER", {
      ...payload,
      src: `${baseUrl}#${payload.src}`,
    });
  },
  SET_RESET_IFRAME_DRAWER({ commit }) {
    commit("SET_RESET_IFRAME_DRAWER");
  },
};

export default { state, getters, mutations, actions };
